export class FileDownloadResult {    
  fileName: string;
  fileContent: Blob;
}
